<template>
  <div>
    <v-dialog
      :value="isObservationsDialogOpen"
      width="1000"
      @input="inputObservationsDialog"
    >
      <v-card class="rounded-lg">
        <v-card-title class="justify-center">
          <span class="title">
            {{ $t("organization.details.observations") }}
          </span>
          <v-btn icon class="close_icon" @click="close">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <v-row no-gutters>
            <v-col col="12">
              <VueEditor v-model="localObservation" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters class="mb-4">
            <v-col cols="12" class="d-flex justify-end align-center">
              <v-btn
                color="#2661FF"
                class="rounded-lg mr-2"
                :loading="isLoading"
                @click="save"
              >
                <span class="white--text">
                  {{ $t("actions.save") }}
                </span>
                <v-icon class="ml-1" color="white">
                  upload
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { VueEditor } from "vue2-quill-editor";

export default {
  name: "ObservationDialog",
  components: {
    VueEditor
  },
  data() {
    return {
      localObservation: null,
      isLoading: false
    };
  },
  created() {
    this.localObservation = this.organization.observations;
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      isObservationsDialogOpen: ({
        organization: { isObservationsDialogOpen }
      }) => isObservationsDialogOpen
    })
  },
  methods: {
    ...mapActions({
      updateOrganization: "organization/updateOrganization"
    }),
    ...mapMutations({
      toggleObservationsDialog: "organization/toggleObservationsDialog"
    }),
    inputObservationsDialog(arg) {
      if (!arg) {
        this.close();
      }
    },
    close() {
      this.toggleObservationsDialog(false);
    },
    async save() {
      this.isLoading = true;

      const payload = {
        id: this.organization.id,
        body: {
          observations: this.localObservation
        }
      };

      await this.updateOrganization(payload);

      this.close();

      this.isLoading = false;
    }
  }
};
</script>
<style>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}

.close_icon {
  position: absolute;
  top: 14px;
  right: 15px;
}
</style>
